import React, { useEffect } from "react";
import PropTypes from "prop-types";
import {
  Typography,
  Grid,
  makeStyles,
} from "@material-ui/core";
import { planActions } from "../../store/actions/plans/plans";
import { compose } from "../../utils/compose";
import { connect } from "react-redux";
import InlineSpinner from "../UI/InlineSpinner/InlineSpinner";
import PlanCard from "./PlanCard";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  root: {
    "@global": {
      ul: {
        margin: 0,
        padding: 0
      },
      li: {
        listStyle: "none"
      }
    }
  },
  center: {
    textAlign: "center"
  },
  spinnerSize: {
    height: "24px"
  },
  cardContainer: {
    display: "flex"
  }
}));

const SetupTrialPlan = props => {
  const classes = useStyles();
  const {
    fetching,
    list,
    error,
    onPlanSelected,
    onFetchAvailablePlans,
    submitting,
  } = props;
  const {t} = useTranslation();
  const planList = [...list];
  planList.sort((a,b) => a.Price - b.Price);

  useEffect(() => {
    onFetchAvailablePlans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const planSelectedHandler = plan => {
    onPlanSelected(plan);
  };


  let element = <InlineSpinner size="small" align="center" />;

  if (!fetching) {
    if (error) {
      element = <Typography variant="body1">{t('somethingWentWrongWeb')}</Typography>;
    } else if(planList.length === 0) {
      element = <Typography variant="body1">{t('noPlansAvailable')}</Typography>
    } else {
      element = (
        <Grid
          container
          spacing={5}
          alignItems="stretch"
          className={classes.root}
        >
          {planList.map(p => {
            return (
              <Grid item key={p.Id} xs={12} md={6} className={classes.cardContainer}>
                <PlanCard plan={p} withAction={planSelectedHandler} submitting={submitting} />
              </Grid>
            );
          })}
        </Grid>
      );
    }
  }

  return element;
};

SetupTrialPlan.propTypes = {
  onPlanSelected: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  fetching: state.plans.fetching,
  list: state.plans.data,
  error: state.plans.error
});

const mapDispatchToProps = dispatch => ({
  onFetchAvailablePlans: () => dispatch(planActions.fetchAvailable())
});

const composed = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(SetupTrialPlan);

export default composed;
